import { colors } from '@mui/material'

const white = '#FFF'
const black = '#000'

export default {
  white,
  black,
  primary: {
    main: '#de1738',
  },
  secondary: {
    contrastText: white,
    main: '#4fc5cf',
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600],
  },
  link: colors.blue[800],
  icon: colors.blueGrey[600],
  background: {
    default: '#eee',
    paper: white,
  },
  divider: colors.grey[200],
}
